import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { LocalizationProvider } from "./contexts/LocalizationContext";
import { CityResponsiveLayout, YunLinResponsiveLayout } from "./layouts";
import {
  AnalyzingPage,
  ChatbotPage,
  CountyMagistratePage,
  PickScamPage,
  PreviewImagePage,
  ResultPage,
  ScamResultPage,
  VerifyingPage,
} from "./pages";
import "./styles.css";

export default function App() {
  return (
    <LocalizationProvider>
      <BrowserRouter>
        <Routes>
          {/* 多數頁：不捲動、背景往下看 120px */}
          <Route
            element={
              <CityResponsiveLayout
                options={{
                  bgOffsetY: 200,
                  footerFixed: true,
                  footerHeight: 38,
                  overflowY: "hidden",
                }}
              />
            }
          >
            <Route index element={<ChatbotPage />} />
            <Route path="analyzing" element={<AnalyzingPage />} />
          </Route>

          {/* 結果頁：可捲動、footer 不固定；背景多露一點下緣所以位移小一些 */}
          <Route
            element={
              <CityResponsiveLayout
                options={{
                  bgOffsetY: 60,
                  footerFixed: false,
                  overflowY: "scroll",
                }}
              />
            }
          >
            <Route path="preview-image" element={<PreviewImagePage />} />
            <Route path="result" element={<ResultPage />} />
          </Route>

          {/* [雲林] 雲林縣長 event */}
          <Route
            element={
              <YunLinResponsiveLayout
                options={{
                  bgOffsetY: 200,
                  footerFixed: true,
                  footerHeight: 38,
                  overflowY: "hidden",
                }}
              />
            }
          >
            <Route
              path="county-magistrate"
              element={<CountyMagistratePage />}
            />
          </Route>

          {/* [雲林] 結果頁：可捲動、footer 不固定；背景多露一點下緣所以位移小一些 */}
          <Route
            element={
              <YunLinResponsiveLayout
                options={{
                  bgOffsetY: 60,
                  footerFixed: false,
                  overflowY: "scroll",
                }}
              />
            }
          >
            <Route path="pick-scam" element={<PickScamPage />} />
            <Route path="verifying" element={<VerifyingPage />} />
            <Route path="scam-result" element={<ScamResultPage />} />
          </Route>

          {/* fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </LocalizationProvider>
  );
}
